import { matchRoutes, useLocation } from 'react-router-dom'

import {
  budgetRoutes,
  buyListRoutes,
  catalogRoutes,
  creditNoteRoutes,
  inventoryRoutes,
  invoiceRoutes,
  myProductsRoutes,
  organisationsRoutes,
  paperlessEmailsRoutes,
  pointOfSaleRoutes,
  purchaseOrderRoutes,
  purchaserRoutes,
  quoteRoutes,
  recipeRoutes,
  reportsRoutes,
  requisitionRoutes,
  supplierRoutes,
  systemSettingRoutes,
  usersRoutes,
} from '@/modules/shared/constants'

const useFindMatchRoutes = () => {
  const location = useLocation()

  const allRoutes = {
    requisitionRoutes,
    purchaseOrderRoutes,
    invoiceRoutes,
    creditNoteRoutes,
    buyListRoutes,
    catalogRoutes,
    paperlessEmailsRoutes,
    myProductsRoutes,
    recipeRoutes,
    inventoryRoutes,
    supplierRoutes,
    reportsRoutes,
    usersRoutes,
    systemSettingRoutes,
    purchaserRoutes,
    pointOfSaleRoutes,
    quoteRoutes,
    budgetRoutes,
    organisationsRoutes,
    // ... Add more as needed
  }

  const findSideBarIndexKey = (allRouteKey: string) => {
    return Object.keys(allRoutes).findIndex((routeKey) => routeKey === allRouteKey)
  }

  const matchedRouteIndex = Object.values(allRoutes).findIndex((route) => matchRoutes(route, location))

  const routeMatches = Object.values(allRoutes).map((_, index) => index === matchedRouteIndex)

  const sideBarIndexKeys: Record<string, number> = {
    requisitionSideBarKey: findSideBarIndexKey('requisitionRoutes'),
    purchaseOrdersSideBarKey: findSideBarIndexKey('purchaseOrderRoutes'),
    invoiceSideBarKey: findSideBarIndexKey('invoiceRoutes'),
    creditNoteSideBarKey: findSideBarIndexKey('creditNoteRoutes'),
    buyListSideBarKey: findSideBarIndexKey('buyListRoutes'),
    catalogSideBarKey: findSideBarIndexKey('catalogRoutes'),
    quoteSideBarKey: findSideBarIndexKey('quoteRoutes'),
    paperlessEmailsSideBarKey: findSideBarIndexKey('paperlessEmailsRoutes'),
    myProductSideBarKey: findSideBarIndexKey('myProductsRoutes'),
    recipeSideBarKey: findSideBarIndexKey('recipeRoutes'),
    inventorySideBarKey: findSideBarIndexKey('inventoryRoutes'),
    supplierSideBarKey: findSideBarIndexKey('supplierRoutes'),
    reportsSideBarKey: findSideBarIndexKey('reportsRoutes'),
    usersSideBarKey: findSideBarIndexKey('usersRoutes'),
    systemSettingSideBarKey: findSideBarIndexKey('systemSettingRoutes'),
    purchaserSidebarKey: findSideBarIndexKey('purchaserRoutes'),
    pointOfSaleSideBarKey: findSideBarIndexKey('pointOfSaleRoutes'),
    budgetSideBarKey: findSideBarIndexKey('budgetRoutes'),
    organisationsSideBarKey: findSideBarIndexKey('organisationsRoutes'),
    // ... Add more as needed
  }

  return {
    requisitionRoutesMatch: routeMatches[sideBarIndexKeys.requisitionSideBarKey],
    purchaseOrdersRoutesMatch: routeMatches[sideBarIndexKeys.purchaseOrdersSideBarKey],
    invoiceRoutesMatch: routeMatches[sideBarIndexKeys.invoiceSideBarKey],
    creditNoteRoutesMatch: routeMatches[sideBarIndexKeys.creditNoteSideBarKey],
    buyListRoutesMatch: routeMatches[sideBarIndexKeys.buyListSideBarKey],
    catalogRoutesMatch: routeMatches[sideBarIndexKeys.catalogSideBarKey],
    quoteRoutesMatch: routeMatches[sideBarIndexKeys.quoteSideBarKey],
    paperlessEmailsRoutesMatch: routeMatches[sideBarIndexKeys.paperlessEmailsSideBarKey],
    myProductRoutesMatch: routeMatches[sideBarIndexKeys.myProductSideBarKey],
    recipeRoutesMatch: routeMatches[sideBarIndexKeys.recipeSideBarKey],
    inventoryRoutesMatch: routeMatches[sideBarIndexKeys.inventorySideBarKey],
    supplierRoutesMatch: routeMatches[sideBarIndexKeys.supplierSideBarKey],
    reportsRoutesMatch: routeMatches[sideBarIndexKeys.reportsSideBarKey],
    usersRoutesMatch: routeMatches[sideBarIndexKeys.usersSideBarKey],
    organisationsRoutesMatch: routeMatches[sideBarIndexKeys.organisationsSideBarKey],
    systemSettingRoutesMatch: routeMatches[sideBarIndexKeys.systemSettingSideBarKey],
    purchaserRoutesMatch: routeMatches[sideBarIndexKeys.purchaserSidebarKey],
    pointOfSaleRoutesMatch: routeMatches[sideBarIndexKeys.pointOfSaleSideBarKey],
    budgetRoutesMatch: routeMatches[sideBarIndexKeys.budgetSideBarKey],
    sideBarIndexKeys,
    accordionDefaultKey: matchedRouteIndex !== -1 ? matchedRouteIndex : null,
  }
}

export default useFindMatchRoutes
